import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import RestrictedPath from "./RestrictedPath";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Shortcuts = /*#__PURE__*/lazy(function () {
  return import("pages/admin/shortcuts/Shortcuts");
});
var MeasuresAdmin = /*#__PURE__*/lazy(function () {
  return import("pages/admin/measures/MeasuresAdmin");
});
var Keywords = /*#__PURE__*/lazy(function () {
  return import("pages/admin/keywords/KeywordsAdmin");
});
var Healthcheck = /*#__PURE__*/lazy(function () {
  return import("pages/admin/healthcheck/Healthcheck");
});
var Developer = /*#__PURE__*/lazy(function () {
  return import("pages/admin/developer/Developer");
});

//constructedContent
var ManageCompositions = /*#__PURE__*/lazy(function () {
  return import("pages/admin/compositions/manage-compositions");
});
var ManageCategories = /*#__PURE__*/lazy(function () {
  return import("pages/admin/compositions/composition-categories");
});
var CreateNewComposition = /*#__PURE__*/lazy(function () {
  return import("pages/admin/compositions/create-new-composition");
});
var CompositionEditor = /*#__PURE__*/lazy(function () {
  return import("pages/admin/compositions/composition-editor");
});
var AdminEntries = function AdminEntries(props) {
  return /*#__PURE__*/_jsxs(Routes, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "indikatorer/installningar",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "measures",
        children: /*#__PURE__*/_createElement(MeasuresAdmin, _objectSpread(_objectSpread({}, props), {}, {
          key: "indikatorer/installningar"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "indikatorer/nya-indikatorer",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "measures",
        children: /*#__PURE__*/_createElement(MeasuresAdmin, _objectSpread(_objectSpread({}, props), {}, {
          key: "indikatorer/nya-indikatorer"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "indikatorer/avrundning",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "measures",
        children: /*#__PURE__*/_createElement(MeasuresAdmin, _objectSpread(_objectSpread({}, props), {}, {
          key: "indikatorer/avrundning"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "nyckelord",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "headKeyword",
        children: /*#__PURE__*/_createElement(Keywords, _objectSpread(_objectSpread({}, props), {}, {
          key: "nyckelord"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "systemstatus",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "systemStatus",
        children: /*#__PURE__*/_createElement(Healthcheck, _objectSpread(_objectSpread({}, props), {}, {
          key: "systemstatus"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "utvecklare",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "developer",
        children: /*#__PURE__*/_createElement(Developer, _objectSpread(_objectSpread({}, props), {}, {
          key: "utvecklare"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "innehall/kategorier",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "category",
        children: /*#__PURE__*/_createElement(ManageCategories, _objectSpread(_objectSpread({}, props), {}, {
          key: "innehall/kategorier"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "innehall/skapa",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "contenteditor",
        children: /*#__PURE__*/_createElement(CreateNewComposition, _objectSpread(_objectSpread({}, props), {}, {
          key: "innehall/skapa"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "innehall/sidor",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "page",
        children: /*#__PURE__*/_createElement(ManageCompositions, _objectSpread(_objectSpread({}, props), {}, {
          key: "innehall/sidor"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "innehall/rapporter",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "report",
        children: /*#__PURE__*/_createElement(ManageCompositions, _objectSpread(_objectSpread({}, props), {}, {
          key: "innehall/rapporter"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "innehall/nyheter",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "news",
        children: /*#__PURE__*/_createElement(ManageCompositions, _objectSpread(_objectSpread({}, props), {}, {
          key: "innehall/nyheter"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "sida/:id",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "page",
        children: /*#__PURE__*/_createElement(CompositionEditor, _objectSpread(_objectSpread({}, props), {}, {
          key: "sida/:id"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "rapport/:id",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "report",
        children: /*#__PURE__*/_createElement(CompositionEditor, _objectSpread(_objectSpread({}, props), {}, {
          key: "rapport/:id"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "nyhet/:id",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "news",
        children: /*#__PURE__*/_createElement(CompositionEditor, _objectSpread(_objectSpread({}, props), {}, {
          key: "nyhet/:id"
        }))
      })
    })]
  });
};
export default function adminRoutes(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/admin",
      element: /*#__PURE__*/_jsx(RestrictedPath, {
        resource: "shortcuts",
        children: /*#__PURE__*/_createElement(Shortcuts, _objectSpread(_objectSpread({}, props), {}, {
          key: "/admin-home"
        }))
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "/admin/*",
      element: /*#__PURE__*/_jsx(AdminEntries, _objectSpread({}, props))
    })]
  });
}